import { FC, ReactNode, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import useGetCurrentProductName from 'src/hooks/useGetCurrentProductName'
import usePrinter from 'src/hooks/usePrinter'
import useTracking from 'src/hooks/useTracking'
import { getProductSuffixNameFn } from 'src/utils/productUtils'
import { parseURL } from 'src/utils/urls'

interface PageProps {
  title?: string
  children: ReactNode
  isWithSuffix?: boolean
}

const PAGE_SUFFIX = ' | Adomik Platform'
const UNKNOWN_PAGE = 'Adomik Platform'
const PRINT_TITLE = 'Report Dashboard Download'

const Page: FC<PageProps> = ({ children, title, isWithSuffix: isWithSuffixProp = true }) => {
  const { trackPageView } = useTracking()
  const { printMode } = usePrinter()

  const { pathname } = useLocation()

  const productElement = useGetCurrentProductName()

  const { product: productFormPathname } = parseURL(pathname)
  const parentName = productElement ? getProductSuffixNameFn(productElement.parentName) : undefined
  const space = parentName ? ' ' : ''
  const productName = productElement ? `${parentName}${space}${productElement.name}` : undefined

  const pageTitle = printMode ? PRINT_TITLE : productName || title || productFormPathname

  const isWithSuffix = isWithSuffixProp || printMode

  const pageTitleWithSuffix = `${pageTitle}${isWithSuffix ? PAGE_SUFFIX : ''}`

  useEffect(() => {
    if (pageTitleWithSuffix === UNKNOWN_PAGE) {
      return
    }
    document.title = pageTitleWithSuffix
    trackPageView(pageTitleWithSuffix)
  }, [pageTitleWithSuffix, pageTitle, printMode, trackPageView])

  return <>{children}</>
}

export default Page
